module.exports = __webpack_public_path__ + "static/media/promulgation-landing-support-station.03594687.png";